import CategoryCard from "Pages/category/categoryCard";
import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { trendingArtWork } from "store/actions";

const TrendingNFT = () => {
  const { trendingArtWorks } = useSelector((state) => state?.SellItems);
  const [trendingNft, setTrendingNft] = useState([])
  const dispatch = useDispatch();
  const [filter, setfilter] = useState({
    count: 30,
  });
  useEffect(() => {
    setTrendingNft(trendingArtWorks.slice(8, 12));
  }, [trendingArtWorks])
   useEffect(() => {
    dispatch(trendingArtWork(filter));
  }, [filter, dispatch]);


  return (
    <div className=" container-fluid tranendingnft">
      <Container>
        <Row>
          <Col lg={12}>
            <div className="d-flex align-items-baseline justify-content-between">
              <div className="DigitalArtcollection-head">
                <h2>Trending Artworks</h2>
              </div>
              {/* <Link className="viewText" to="/art-genres" style={{}}  >View all</Link> */}
            </div>
          </Col>
        </Row>
        <div className="tranendingnftMain">
          <Row>
            {trendingNft.length > 0 ? trendingNft?.map((nftData, ind) =>
              <Col lg={3}>
                <CategoryCard data={nftData} key={ind} />
              </Col>
            ) :
              <div className="text-center d-grid justify-content-center dataNotFound py-5">
                <img src={"../../images/svg/mpdatanft.svg"} className="mb-4" alt="Create collection" />

                <h3>No Trending Artworks Available</h3>
              </div>
            }
          </Row>
        </div>
      </Container>
    </div>
  );
};

export default TrendingNFT;
